<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/campanhas" name="Pesquisas" icon="fas fa-poll-h" />
        <sidebar-link to="/marcas" name="Marcas" icon="fas fa-store-alt" />
        <sidebar-link to="/questions" name="Perguntas" icon="tim-icons icon-chart-pie-36" />
        <sidebar-link to="/ramos" name="Ramos" icon="tim-icons icon-notes" />
        <sidebar-link to="/parceiros" name="Parceiros" icon="tim-icons icon-trophy" />
        <sidebar-link to="/surveyClasses" name="Classes" icon="tim-icons icon-chat-33" />
        <sidebar-link to="/profileQuestions" name="Perguntas de Perfil" icon="tim-icons icon-chat-33" />
        <sidebar-link to="/config" name="Configurações Globais" icon="tim-icons icon-world" />
        <sidebar-link to="/usuarios" name="Usuários" icon="fas fa-users" />
        <sidebar-link to="/productsAndServices" name="Produtos E Serviços" icon="tim-icons icon-notes" />
        <sidebar-link to="/brandTypes" name="Tipos de marca" icon="fas fa-store-alt" />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './MobileMenu';
export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
